import React, { useState } from 'react';
import { apiputFormData } from '../ApiUrls';
import { toast } from 'react-toastify';

const UpdateProfileImageModal = ({
    show,
    onClose,
    GetHostessProfile
}) => {

    const [profileImage, setProfileImage] = useState(null);
    const handleProfileImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setProfileImage(file);
        }
    };


    const [IsUploading, setIsUploading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsUploading(true);

        const formData = new FormData();
        if (profileImage) {
            formData.append('Image', profileImage);
        }

        try {
            const response = await apiputFormData('api/hostess/UploadProfileImage', formData);
            toast.success(response?.message);
            setProfileImage(null)
            onClose()
            GetHostessProfile()
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to upload gallery.');
            console.error('Error uploading images:', error);
        } finally {
            setIsUploading(false);
        }
    };

    if (!show) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h2>Update Profile Image</h2>
                <br />
                <div className="container">
                    <div className="box">
                        <input
                            type="file"
                            accept="image/*"
                            className="input"
                            onChange={handleProfileImageChange}
                        />
                        {profileImage ? (
                            <img
                                src={URL.createObjectURL(profileImage)}
                                alt="Profile Preview"
                                className="image"
                            />
                        ) : (
                            <p className="placeholder">Click to select</p>
                        )}
                    </div>
                </div>
                <br />
                <div className='center' style={{ gap: 20 }}>
                    <button onClick={handleSubmit} disabled={IsUploading}>
                        {IsUploading ? 'Uploading...' : 'Update'}
                    </button>
                    <button onClick={() => { onClose() }}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default UpdateProfileImageModal;

